import { PUBLIC_VIVENU_FRONTEND_URL, PUBLIC_VIVENU_SELLER_ID } from '$env/static/public';
import type { PublicListingEvent, VivenuExchangeToken } from './vivenu/types';

export function buildVivenuLoginUrl(targetUrl: string, exchangeToken?: string) {
	if (!exchangeToken) return targetUrl;

	const params = new URLSearchParams({
		redirect_uri: targetUrl,
		exchangeToken
	});

	const loginUrl = `${PUBLIC_VIVENU_FRONTEND_URL}/seller/${PUBLIC_VIVENU_SELLER_ID}/auth/redirect`;
	return `${loginUrl}?${params}`;
}

export function buildEventUrl(
	event: PublicListingEvent,
	vivenuExchangeToken?: VivenuExchangeToken
): string {
	if (event.meta?.away_request) {
		const gameSerial = encodeURIComponent(event.meta.game_serial || '');
		const gameDay = encodeURIComponent(event.meta.game_day || '');
		return `/auswaerts/anfragen/${gameSerial}/${gameDay}`;
	}

	const baseEventUrl = `${PUBLIC_VIVENU_FRONTEND_URL}/event/${event.url}`;
	return buildVivenuLoginUrl(baseEventUrl, vivenuExchangeToken?.exchangeToken);
}

export const isExternal = (url: string) => url.includes('://');
export const isInternal = (url: string) => !isExternal(url);
